module.exports = __webpack_public_path__ + "static/img/69082H_1_C_20210320_LC.60654cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/69082H_1_C_20210320_LC.png
// module id = 6A7q
// module chunks = 0